import styled from "styled-components";
import bannerImg from "../../images/bannerimg.png";

export const DashboardWrapper = styled.div`
  background: #F0F4F8;
  min-height: 100vh;
  padding: 2rem;

  .carde {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-block: 35px;
    > div {
      flex: 1 1 30%;
    }
  }
  .banner {
    gap: 20px;
    margin-block: 35px;
    flex-wrap: wrap;
    .card {
      background: #FFFFFF;
      box-shadow: 0 4px 20px rgba(45, 95, 122, 0.08);
      border-radius: 16px;
      border: 1px solid #E2E8F0;
      flex: 1 1 30%;
      max-width: 420px;
      min-width: 280px;
      min-height: 242px;
      transition: all 0.3s ease;
      
      &:hover {
        box-shadow: 0 8px 30px rgba(45, 95, 122, 0.12);
        border-color: #7BC4E0;
      }

      &.card1 {
        background: linear-gradient(135deg, #1A2F3A 0%, #0F2128 100%);
        background-size: cover;
        background-position: bottom right;
        padding: 30px 20px;
        h2 {
          color: #FFFFFF;
          font-size: 28px;
          line-height: 34px;
          font-weight: 600;
        }
      }
      &.card2 {
        overflow: hidden;
        position: relative;

        img {
          width: 100%;
          transform: scale(1.02);
          opacity: 0.9;
        }
        .play {
          gap: 8px;
          padding: 16px 20px;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(5px);
          border-top: 1px solid #E2E8F0;
          img {
            width: 20px;
            background-color: transparent;
          }
          h2 {
            font-size: 14px;
            color: #1A2F3A;
            font-weight: 600;
            letter-spacing: 0.5px;
          }
        }
      }
      &.card3 {
        padding: 24px;
        h3 {
          font-size: 18px;
          margin-bottom: 12px;
          color: #1A2F3A;
          font-weight: 600;
        }
        p {
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 20px;
          color: #4A5568;
        }
        button {
          background: #2D5F7A;
          color: #FFFFFF;
          border: none;
          padding: 10px 24px;
          border-radius: 8px;
          font-weight: 500;
          transition: all 0.3s ease;
          
          &:hover {
            background: #4a6e81;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(45, 95, 122, 0.2);
          }
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 1rem;
    .hideMD {
      display: none;
    }
  }
`;

export const DashboarCarddWrapper = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px;
  background: #FFFFFF;
  box-shadow: 0 4px 15px rgba(45, 95, 122, 0.06);
  border-radius: 16px;
  border: 1px solid #E2E8F0;
  min-height: 120px;
  max-width: 420px;
  min-width: 280px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: #7BC4E0;
    box-shadow: 0 8px 25px rgba(45, 95, 122, 0.1);
    transform: translateY(-2px);
  }

  .icons {
    width: 56px;
    height: 56px;
    min-width: 56px;
    background-color: #EDF2F7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    transition: all 0.3s ease;

    img {
      width: 28px;
      height: 28px;
      object-fit: contain;
      filter: brightness(0.6);
    }

    &.active {
      background-color: #E6F0F5;
    }
  }

  .rightBox {
    width: 100%;

    .header {
      justify-content: space-between;
      gap: 8px;
      width: 100%;
      margin-bottom: 8px;
    }

    p {
      font-size: 13px;
      line-height: 1.5;
      color: #64748B;
      margin: 0;
    }
  }

  &.current {
    background: linear-gradient(135deg, #2D5F7A 0%, #1E3B4A 100%);
    border-color: #7BC4E0;
    box-shadow: 0 8px 25px rgba(45, 95, 122, 0.2);
  }

  &.current h2 {
    color: #FFFFFF;
  }

  &.current p {
    color: #E2F0F9;
  }
  
  &.current .icons {
    background-color: rgba(255, 255, 255, 0.2);
    img {
      filter: brightness(0) invert(1);
    }
  }

  h2 {
    font-weight: 600;
    color: #1E293B;
    font-size: 16px;
    margin: 0;
  }

  @media only screen and (max-width: 768px) {
    margin-inline: auto;
    padding: 20px;
  }
`;